import useCheckExamStatusByBookIdAndExamIdQuery from './useCheckStatusExamByBookIdAndExamId';

export default useCheckExamStatusByBookIdAndExamIdQuery;
